import { Flex } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';
import { useResellerDetail } from 'hooks';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';

export const StaticDescription = () => {
  const { data: incentiveCampaign } = useLoyaltyIncentiveCampaign();
  const { data: resellerDetail } = useResellerDetail();
  const isLoyaltyMember = resellerDetail?.reseller.isLoyaltyMember ?? false;

  return (
    <Flex direction='column' gap='$10'>
      <ResponsiveFloraTypography fontSize='title' fontWeight='bold' as='h2'>
        Como funciona
      </ResponsiveFloraTypography>
      <Flex direction='column' gap='$6'>
        {isLoyaltyMember ? (
          <ResponsiveFloraTypography
            fontSize='bodyLargeStandard'
            color='$nonInteractivePredominant'
          >
            Os TOP {incentiveCampaign?.limit} {config.communication.userNamingConvention.plural} de
            cada faixa dos programas de fidelidade poderão ganhar 1 bolsa exclusiva e até R$ 1.000
            em produtos! Além da bolsa exclusiva do incentivo, os TOP VIPs (rubi, esmeralda e
            diamante), concorrem a 1 viagem para Bahia com visita à fábrica do Grupo Boticário em
            Camaçari. Saiba mais e confira vagas por faixa no regulamento do incentivo.
          </ResponsiveFloraTypography>
        ) : (
          <ResponsiveFloraTypography
            fontSize='bodyLargeStandard'
            color='$nonInteractivePredominant'
          >
            Os TOP {incentiveCampaign?.limit} {config.communication.userNamingConvention.plural} de
            cada faixa dos programas de fidelidade poderão ganhar 1 bolsa exclusiva e até R$ 1.000
            em produtos! Além da bolsa exclusiva do incentivo, os TOP VIPs (rubi, esmeralda e
            diamante), concorrem a 1 viagem para Bahia com visita à fábrica do Grupo Boticário em
            Camaçari. Saiba mais e confira vagas por faixa no regulamento do incentivo.
            <br />
            <br />
            E mais: participe dos desafios, acumule pontos e multiplique suas chances de conquistar
            recompensas incríveis.
            <br />
            <br />
            São duas formas de ganhar, descubra como aproveitar:
          </ResponsiveFloraTypography>
        )}
      </Flex>
    </Flex>
  );
};
